// スクロールを監視
function setScrollObserver() {
  const scrollanim_elements = document.querySelectorAll(".js-scrollanim");
  const options = {
    root: null,
    rootMargin: "0% 0px -10% 0px",
    threshold: 0,
  };
  const observer = new IntersectionObserver(animationFire, options);
  scrollanim_elements.forEach((elm) => {
    observer.observe(elm);
  });
}
/**
 * 交差したときに呼び出す関数
 * @param entries
 */
// function animationFire(entries) {
//   // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       entry.target.classList.add("js-scrollanim--fired");
//     } else {
//       // entry.target.classList.remove('scrollanim_fired')
//     }
//   });
// }
function animationFire(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const delay = parseInt(entry.target.getAttribute("data-delay") ? entry.target.getAttribute("data-delay") : 0);
      setTimeout(() => {
        entry.target.classList.add("js-scrollanim--fired");
        if (entry.target.classList.contains("js-shuffleLetters")) {
          setShuffleLetter(entry.target);
        }
      }, delay);
    } else {
      // entry.target.classList.remove('scrollanim_fired')
    }
  });
}

function setShuffleLetter(element) {
  if (!element.classList.contains("is-shuffled")) {
    const delay = parseInt(element.getAttribute("data-shuffle-delay")) || 0;
    setTimeout(() => {
      shuffleLetters(element, {
        text: element.textContent,
        step: 5,
        fps: 30,
        callback: () => console.log("shuffle done"),
      });
      element.classList.add("is-shuffled");
    }, delay);
  }
}

function openModal(target) {
  document.querySelector(target).classList.add("is-open");
  body.classList.add("overflow-hidden");
  return false;
}

function setModals() {
  const body = document.getElementsByTagName("body")[0];
  // トリガ
  document.querySelectorAll(".necktie-modal__trigger").forEach((elm) => {
    elm.addEventListener("click", (e) => {
      e.preventDefault();
      const target = e.currentTarget.getAttribute("data-target");
      document.querySelector(target).classList.add("is-open");
      body.classList.add("overflow-hidden");
    });
  });
  // 閉じる
  document.querySelectorAll(".necktie-modal__close").forEach((elm) => {
    elm.addEventListener("click", (e) => {
      e.preventDefault();
      const wrapper = e.currentTarget.closest(".necktie-modal");
      wrapper.classList.remove("is-open");
      body.classList.remove("overflow-hidden");
    });
  });
  document.querySelectorAll(".necktie-modal").forEach((elm) => {
    elm.addEventListener("click", (e) => {
      e.preventDefault();
      if (!e.target.closest(".necktie-modal__content")) {
        const wrapper = e.currentTarget.closest(".necktie-modal");
        wrapper.classList.remove("is-open");
        body.classList.remove("overflow-hidden");
      }
    });
  });
}

/**
 * ヘッダとフッタを読みむ
 * @param none
 */
function setScreenTransition() {
  const linksToOtherPages = Array.from(document.querySelectorAll("a[href]:not(#cart-icon-bubble)")).filter((link) => {
    const href = link.getAttribute("href");
    if (!href) return false;
    if (href.startsWith("#")) return false;
    return true;
  });
  linksToOtherPages.forEach((elm) => {
    elm.addEventListener("click", (e) => {
      const href = e.currentTarget.getAttribute("href");
      const target = e.currentTarget.getAttribute("target") || "_self";

      // javascript: の場合は実行させたいので preventDefault しない
      if (href && href.trim().toLowerCase().startsWith("javascript:")) {
        return; // そのままブラウザに任せる
      }

      // 通常リンクだけ preventDefault
      e.preventDefault();

      if (target === "_self") {
        document.body.classList.add("is-screenTransitioning");
        setTimeout(() => {
          window.open(href, target);
        }, 500);
      } else {
        window.open(href, target);
      }
    });
  });
}

function converter(M) {
  var str = "",
    str_as = "";
  for (var i = 0; i < M.length; i++) {
    str_as = M.charCodeAt(i);
    str += String.fromCharCode(str_as + 1);
  }
  return str;
}
function mail_to(k_1, k_2) {
  eval(
    String.fromCharCode(108, 111, 99, 97, 116, 105, 111, 110, 46, 104, 114, 101, 102, 32, 61, 32, 39, 109, 97, 105, 108, 116, 111, 58) +
      escape(k_1) +
      converter(
        String.fromCharCode(114, 103, 110, 111, 63, 109, 100, 98, 106, 115, 104, 100, 45, 115, 110, 106, 120, 110, 62, 114, 116, 97, 105, 100, 98, 115, 60),
      ) +
      escape(k_2) +
      "'",
  );
}

/**
 * Ready
 * @param none
 */
if (document.readyState !== "loading") {
  onReadyHandler();
} else {
  document.addEventListener("DOMContentLoaded", onReadyHandler);
}

/**
 * Ready ハンドラー
 * @param none
 */
function onReadyHandler() {
  setScrollObserver();
  setModals();
  setScreenTransition();
}

window.addEventListener("pageshow", (event) => {
  // event.persisted が true の場合、bfcache（キャッシュ）から復元された
  if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
    if (document.getElementsByTagName("body")[0].classList.contains("is-screenTransitioning")) {
      document.getElementsByTagName("body")[0].classList.remove("is-screenTransitioning");
    }
  }
});
